<app-notify-message></app-notify-message>
<!-- <app-reports-header></app-reports-header> -->
<div class="tab-content">
  <div role="tabpanel" class="tab-pane fade in active show relative" id="redesign">
    <div class="reports-redesign">
      <div class="redesign-layout">
        <aside class="redesign-sidebar" aria-label="Reports navigation">
          <div class="redesign-sidebar__search">
            <div class="redesign-sidebar__search-field">
              <input
                id="redesign-sidebar-search"
                type="search"
                placeholder="Search"
                class="redesign-sidebar__input"
                autocomplete="off"
                aria-label="Search reports"
              />
              <i class="fa-solid fa-magnifying-glass redesign-sidebar__search-icon" aria-hidden="true"></i>
            </div>
          </div>
          <nav class="redesign-sidebar__nav">
            <button
              type="button"
              class="redesign-sidebar__link"
              [class.redesign-sidebar__link--active]="activeReport === 'product-code-distribution'"
              [attr.aria-current]="activeReport === 'product-code-distribution' ? 'page' : null"
              (click)="selectReport('product-code-distribution')"
            >
              Product Code Report
            </button>
            <button
              type="button"
              class="redesign-sidebar__link"
              [class.redesign-sidebar__link--active]="activeReport === 'operational-insights'"
              [attr.aria-current]="activeReport === 'operational-insights' ? 'page' : null"
              (click)="selectReport('operational-insights')"
            >
              Operational Insights
            </button>
            <button
              type="button"
              class="redesign-sidebar__link"
              [class.redesign-sidebar__link--active]="activeReport === 'protocol-report'"
              [attr.aria-current]="activeReport === 'protocol-report' ? 'page' : null"
              (click)="selectReport('protocol-report')"
            >
              Protocol Report
            </button>
            <button
              type="button"
              class="redesign-sidebar__link"
              [class.redesign-sidebar__link--active]="activeReport === 'sim-usage-report'"
              [attr.aria-current]="activeReport === 'sim-usage-report' ? 'page' : null"
              (click)="selectReport('sim-usage-report')"
            >
              SIM Usage Report
            </button>
          </nav>
        </aside>

        <div class="redesign-main">
          @if (activeReport === 'product-code-distribution') {
          <app-product-code-distribution></app-product-code-distribution>
          } @else if (activeReport === 'operational-insights') {
          <app-operational-insights></app-operational-insights>
          } @else if (activeReport === 'protocol-report') {
          <app-protocol-report></app-protocol-report>
          } @else {
          <app-sim-usage-report></app-sim-usage-report>
          }
        </div>
      </div>
    </div>
  </div>
</div>
